import React, {useContext,useEffect,useState,useRef} from 'react'
import {Card, Typography, Button, Checkbox} from '@mui/material'
import { formularioContext } from '../contextos/FormularioContext'
import Axios from 'axios'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import {Sexo} from './Sexo'
import {Alert} from '@mui/material'
import {useHelper} from '../hooks/useHelper'
import { Ubicacion } from './Ubicacion';
import { TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

  

const regex_solo_numeros = /^[0-9\b]+$/;

export const GrupoPersonas = ()=>{
    const {errorMail,datos,grupo,updateContingente_o_grupo,eventoValorSeleccionado,infoMinistro,provincias} = useContext(formularioContext)
    const [agregar,setAgregar]=useState(true)
    const {hacerScroll} = useHelper()
    const cant_personas_extras = Number(datos.cant_max_personas) > 1 ? Number(datos.cant_max_personas) - 1 : 0;

    const updateGrupo = (param1,param2,param3)=>{
        updateContingente_o_grupo(param1,param2,param3)
        setAgregar(false)
        setTimeout(() => {
            setAgregar(true)
            hacerScroll("atention")
        }, 500);
    }

    if(personasPendientes(grupo,datos)==0){
        return null
    }

    return <Card sx={{
        display: 'flex',
        alignSelf: 'flex-start',
        flexDirection: 'column',
        alignItems: 'flex-start',
        mt: 2,
        mb: 2,
        boxShadow: 'none',
        width: '100%',
    }}> 
    {/* {datos.cant_max_personas > 1 && <Typography style={{margin:'1.5rem',textAlign:'center'}} variant="h4">
       También inscribir a:
    </Typography>} */}
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table id="contingente" aria-label="simple table">
      {grupo.length > 0 && <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>Nombre</TableCell>
            <TableCell align="left">DNI</TableCell>
            <TableCell align="left">Edad</TableCell>
            <TableCell align="left">Sexo</TableCell>
          </TableRow>
        </TableHead>}
        <TableBody>
          {/*<PrimeraLinea datos={datos} infoMinistro={infoMinistro} contingente={contingente} descripcionProvincia={descripcionProvincia}/>*/}
          {grupo.map((row,index) => (
            <>
            <TableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 }}}
            >
              <TableCell align="left"><Typography variant="h6">{index+1}</Typography>
              </TableCell>
              <TableCell align="left"><IconButton title='Borrar a esta persona' onClick={()=>updateGrupo(row,true,true)}><DeleteIcon /></IconButton></TableCell>
              <TableCell align="left">{row?.nombreCompleto ? row?.nombreCompleto : row.nombre}
              </TableCell>
              <TableCell align="left">{row?.nro_documento}</TableCell>
              <TableCell align="left">{row?.edad}</TableCell>
              <TableCell align="left">{row?.sexo}</TableCell>
            </TableRow>
            <TableRow>
                    <TableCell></TableCell>
                    <TableCell>
                            Provincia: {provincias.find(i=>i.id_provincia==row.id_provincia).nombre || 'Desconocido'}
                    </TableCell>
                    <TableCell>
                        {datos.esMatrimonial ? '(Es cónyuge)' : ''}    
                    </TableCell> 
            </TableRow>
            </>
          ))}
          {/* {!agregar && grupo.length > 0 && <TableRow>
                <TableCell colSpan="6" align="left">
                    <Typography align='right'>{grupo.length} participantes de {Number(cant_personas_extras)}</Typography>    
                </TableCell>
          </TableRow>} */}
          {/* {!agregar && Number(cant_personas_extras) > Number(grupo.length) && <TableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 },cursor:'pointer'}}
            >

                <TableCell colSpan="5" align="center"><Button onClick={()=>setAgregar(true)} variant='outlined' color='secondary'>Agregar {grupo.length==0 ? 'una' : 'otra'} persona +</Button></TableCell>
            </TableRow>} */}
        </TableBody>
      </Table>
    </TableContainer>
    {(agregar && personasPendientes(grupo,datos)>0) && <Nuevo hacerScroll = {hacerScroll} 
                solicitante={datos} 
                cantidad_permitida={cant_personas_extras} 
                contingente={grupo} 
                update={updateGrupo} 
                cancelar={()=>setAgregar(false)} errorMail={errorMail}
                eventoValorSeleccionado = {eventoValorSeleccionado}
                provincias={provincias}
                inscriptoPrincipal = {datos.ministroUad=='ministrouad' ? infoMinistro : datos}
                id_provinciaPrincipal = {datos.ministroUad=='ministrouad' ? infoMinistro?.id_provincia : datos?.id_provincia}
                />}

  </Card>   
}

const personasPendientes = (grupo,datos)=>{
    const max_personas = datos.esMatrimonial ? 2 : Number(datos.cant_max_personas)
    return (max_personas-1) - grupo.length
}

const mensajePendientes = (pendientes,matrimonial)=>{

    if(matrimonial && pendientes > 0){
        return 'a su cónyuge'
    }

    switch(pendientes){
        case 0 : return ''
        case 1 :
            return '1 persona'
        default :
            return `${pendientes} personas` 
    }
}

const Nuevo = ({update,
                cancelar,
                contingente,
                eventoValorSeleccionado,
                inscriptoPrincipal,
                id_provinciaPrincipal})=>{
    
    const [datos,setDatos] =  useState({
        nombre:'',
        apellido:'',
        nro_documento:'',
        edad:'',
        id_obrero:null,
        sexo:'M',
        nombreCompleto:'',
        id_provincia:id_provinciaPrincipal
    })
    const [provinciaDefault,setProvinciaDefault]=useState(true)
    const [valorDNIref,setValorDNIref] = useState(null)
    const dniRef = useRef(null)
    const nombreRef = useRef(null)
    // useEffect(()=>{
    //     //hacerScroll('newperson-1')
    //     console.log('reset rendering of Nuevo')
    // },[contingente.length])

    useEffect(()=>{
        if(provinciaDefault){
            setDatos({...datos,id_provincia:id_provinciaPrincipal})
        }
     },[provinciaDefault,id_provinciaPrincipal])

    useEffect(()=>{
        setDatos({...datos,nombreCompleto:`${datos.apellido}, ${datos.nombre}`})
    },[datos.nombre,datos.apellido])

    const handleChangeNombre = (e)=>{
        setDatos({...datos,nombre:e.target.value.trim().toUpperCase()})
    }

    const handleChangeApellido = (e)=>{
        setDatos({...datos,apellido:e.target.value.trim().toUpperCase()})
    }

    const handleChangeDni = (e)=>{
        if(regex_solo_numeros.test(e.target.value.trim()) || e.target.value.trim()==''){
            setDatos({...datos,nro_documento:e.target.value.trim()});
        }
    }

    const handleChangeEdad = (e)=>{
        if(regex_solo_numeros.test(e.target.value.trim()) || e.target.value.trim()==''){
            setDatos({...datos,edad:e.target.value.trim()});
        }
    }

    const handleChangeSexo = (e) => {

        setDatos({...datos,sexo:e.target.value});
    };
   
    const limpiar = ()=>{
        setDatos({
            nombre:'',
            apellido:'',
            nro_documento:'',
            edad:'',
            id_obrero:null,
            sexo:'M',
            nombreCompleto:'',
            id_provincia:id_provinciaPrincipal
        })
        setProvinciaDefault(true)
        setTimeout(() => {
            nombreRef.current.focus()
        }, 500);
    }
    const buscarHabilitacionExterno = async (dni,nro_opcion)=>{
        if (!nro_opcion)throw new Error('El item seleccionado no tiene información suficiente para validar su DNI') // cuando no tenemos aún el detalle del pago (Revisar, funcionaba en los pagos viejos)
        try{
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/eventos/externo/habilitacion/${dni}/${16}/${2}`:`https://uadapi.uad.digital/api/eventos/externo/habilitacion/${dni}/${16}/${2}`)
            if (data.length>0){
                if(data[0]?.autorizado){
                    return true
                }else{
                    return false
                }
            }else{
                return null
            }
        }
        catch(err){
            console.log(err)
            throw new Error(err.response.data.message) // aquí se captura los errores de axios y viene el mensaje de error en err.response.data
                                // debo forzar un throw error para que en el punto en donde se llamó a la función capture el error en el catch si no no lo interpreta como un error
        }
    }

    const buscarDatosPersona = async (dni)=>{

        try{
            const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/eventos/participante/info/${dni}/${eventoValorSeleccionado.id_evento}`:`https://uadapi.uad.digital/api/eventos/participante/info/${dni}/${eventoValorSeleccionado.id_evento}`)
            // si el dni está inscripto llega como error
            // si llega data es un ministro UAD no inscripto
            // si no llega data es porque no es ni ministro uad ni inscripto
            if (data){
               return data
            }else{
                return null
            }
        }
        catch(err){
            console.log(err)
            throw new Error(err.response.data.message) // aquí se captura los errores de axios y viene el mensaje de error en err.response.data
                                // debo forzar un throw error para que en el punto en donde se llamó a la función capture el error en el catch si no no lo interpreta como un error
        }
    }

     const iniciarGrabar = async ()=>{
        if(datosMinistroOk()[0]){

            try{
                const persona = await dniEsMinUad(datos.nro_documento);
                const esMinUadOK = persona[0] && persona[1];
                const esExternoOK = persona[0]
                const huboError = !persona[0]
    
                let resultado = true;

                if(esMinUadOK){
                    if(datos?.id_obrero==persona[1]?.referencia){
                        console.log('iniciarGrabar - El dni es ministro uad y fue agregado automáticamente')
                    }else{
                        resultado=false;
                        alert('No se puede agregar a la persona seleccionada. Hay un conflicto con el número de DNI. El DNI corresonde a un ministro UAD. Vuelva a ingresar el DNI y acepte que se completen automáticamente los datos')
                        resetFocusDNI()
                    }    
                }else if(esExternoOK){
                    console.log('iniciarGrabar - El dni no es ministro uad ni un inscripto')
                }else if (huboError){
                    resultado=false;
                    alert(persona[1])
                    resetFocusDNI()
                }else{
                    resultado = false;
                    alert('Error en iniciarGrabar. No se pudo determinar el estado del ministro asociado al DNI ingresado ')
                    resetFocusDNI()
                }

                if(resultado){
                    update(datos,false,true)
                }
            }catch(err){
                alert(err)
            }
        }else{
            alert(datosMinistroOk()[1])
        }

    }

    const resetFocusDNI = ()=>{
        setDatos({...datos,nro_documento:''})
        setTimeout(() => {
            dniRef.current.focus()
        }, 500);
    }

    const dniEsMinUad = async (dni)=>{
        try{
            const personaValidada = await buscarDatosPersona(dni)

            if(personaValidada){
                return [true,personaValidada] // es ministro uad, no está inscripto y estos son sus datos
            }else{
                if(!eventoValorSeleccionado?.validar_dni_externos){
                    return [true] // Puede avanzar
                }

                const validarHabilitado = await buscarHabilitacionExterno(dni,eventoValorSeleccionado.nro_opcion)
                if(validarHabilitado){
                    return [true] // no es ministro uad y no está inscripto y está habilitado
                }else{
                     return [false,'El DNI ingresado no se encuentra autorizado. Por favor contacte a la mesa de ayuda']
                }
            }

        }catch(err){
            return [false,err] // es un error por ejemplo el DNI ya está inscripto
        }
    }

    const manageOnBlurDNI = async (e)=>{
        if(e.target.value && e.target.value!=valorDNIref){

            try{
                const persona = await dniEsMinUad(e.target.value);
                const esMinUadOK = persona[0] && persona[1];
                const esExternoOK = persona[0]
                const huboError = !persona[0]
    
                if(esMinUadOK){
                    agregarMinUadAutomaticamente(persona)
                }else if(esExternoOK){
                    console.log('manageOnBlurDNI - El dni no es ministro uad ni un inscripto')
                }else if (huboError){
                    alert(persona[1])
                }else{
                    alert('Error en manageOnBlurDNI. No se pudo determinar el estado del ministro asociado al DNI ingresado ')
                }
            }catch(err){
                alert(err)
            }
        }
    }

    const agregarMinUadAutomaticamente = (infoPersona)=>{
        const confirmar = window.confirm('El DNI ingresado corresponde a un ministro UAD. Se van a completar los datos automáticamente');
        if(confirmar){
            const newPerson = {
                nombre:infoPersona[1].nombre,
                apellido:'(UAD)',
                nro_documento:`${infoPersona[1].nro_documento}`,
                edad:infoPersona[1].edad,
                id_obrero:infoPersona[1].referencia,
                sexo:infoPersona[1].sexo,
                nombreCompleto:infoPersona[1].nombre,
                id_provincia:infoPersona[1].id_provincia
            }
            setDatos(newPerson)
            setProvinciaDefault(false)
        }else{
            resetFocusDNI()
        }
    }
    const manageOnFocusDNI = (e)=>{
        setValorDNIref(e.target.value)
    }

    const datosMinistroOk = ()=>{

            if(datos.nombre.trim()==''){
                return [false,`Falta completar el nombre`]
            }
    
            if(datos.apellido.trim()==''){
                return [false,`Falta completar el apellido`]
            }
    
            if(!datos.sexo || datos.sexo.trim()==''){
                return [false,`Falta completar el género`]
            }

            if(datos.nro_documento.trim()==''){
                return [false,`Falta completar el número de documento`]
            }

            if(datos.nro_documento.trim().length>9){
                return [false,`El número de documento es demasiado largo`]
            }

            if(datos.nro_documento.trim().length<7){
                return [false,`El número de documento requiere al menos 7 dígitos`]
            }
            
            if(!datos.edad || Number(datos.edad)==0){
                return [false,`Falta completar la edad`]
            }

            if(inscriptoPrincipal.sexo==datos.sexo && eventoValorSeleccionado.matrimonio){
                return [false,'El sexo de conyuge debe ser diferente al del inscripto principal']
            }

            if(eventoValorSeleccionado){
                if(eventoValorSeleccionado?.rango_edad){
                    const rangoEdad = eventoValorSeleccionado?.rango_edad.split(',');
                    const controlEdad = Number(datos.edad) 
                    if(controlEdad<Number(rangoEdad[0]) || controlEdad>Number(rangoEdad[1])){
                        return [false,`El tipo de inscripción seleccionado requiere un rango de edad entre ${rangoEdad[0]} y ${rangoEdad[1]}`]
                    }
                }else{
                    return [false,`No se ha especificado el rango de edad para la inscripción seleccionada. Por favor comuníquese con la ofina UAD`]
                }
            }else{
                return [false,`No se identificó el tipo de inscripción seleccionado`]
            }

        return [true,null]
    }

    if(!id_provinciaPrincipal || id_provinciaPrincipal==-1){
        return <div>
            <h1>Falta la provincia del inscripto principal</h1>
        </div>
    }

    return <Card style={{background: '#fbfbfb',padding:'2px', borderWidth: '1px', borderColor: '#ddd', borderStyle: 'solid'}}>
        {/* Participante {contingente.length+1} de {cantidad_permitida}  */}
        <Typography id="newperson-1" 
            style={{ fontWeight: 600,marginTop:'1rem',paddingLeft:'0.5rem', fontSize: 18 }} variant="caption" display="block">
            {eventoValorSeleccionado.matrimonio ? 'Ingrese los datos de su cónyuge:':'Ingrese una nueva persona:'}
        </Typography>
    <TableContainer>
    <Table>
    <TableBody>
    <TableRow title="Solicitante" sx={{ background: "" }}>
        <TableCell sx={{ verticalAlign: "top" }} colSpan="6" align="left">
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>

                                <TextField
                    inputProps={{ maxLength: 9 }}
                    id="dp-dni"
                    value={datos.nro_documento}
                    onBlur={manageOnBlurDNI}
                    onFocus={manageOnFocusDNI}
                    inputRef={dniRef}
                    disabled={!!datos.id_obrero}
                    style={{ backgroundColor: "#fff" }}
                    fullWidth
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            manageOnBlurDNI(e);
                        }
                    }}
                    onChange={handleChangeDni}
                    label="DNI"
                    variant="filled"
                    autoFocus={contingente.length > 0 ? true : false}
                />

                <TextField
                    style={{ fontSize: "small", backgroundColor: "#fff" }}
                    disabled={!!datos.id_obrero}
                    inputRef={nombreRef}
                    fullWidth
                    inputProps={{ maxLength: 25 }}
                    id="dp-nombre"
                    value={datos.nombre}
                    onChange={handleChangeNombre}
                    label="Nombre"
                    variant="filled"
                />

                <TextField
                    style={{ display: !!datos.id_obrero ? "none" : "block", backgroundColor: "#fff" }}
                    fullWidth
                    inputProps={{ maxLength: 25 }}
                    id="dp-apellido"
                    value={datos.apellido}
                    disabled={!!datos.id_obrero}
                    onChange={handleChangeApellido}
                    label="Apellido"
                    variant="filled"
                />
                <TextField
                    inputProps={{ maxLength: 2 }}
                    style={{ backgroundColor: "#fff" }}
                    id="dp-edad"
                    value={datos.edad}
                    disabled={!!datos.id_obrero}
                    onChange={handleChangeEdad}
                    label="Edad"
                    variant="filled"
                />

                <Sexo
                    disabled={!!datos.id_obrero}
                    sexo={datos.sexo}
                    handleChangeSexo={handleChangeSexo}
                />

                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginTop: -5 }}>
                    <Checkbox
                        disabled={!!datos.id_obrero}
                        checked={provinciaDefault}
                        onChange={(e) => setProvinciaDefault(provinciaDefault ? false : true)}
                    />
                    <Typography variant="body2">
                        Asignar automáticamente la misma provincia del inscripto principal
                    </Typography>
                </div>

                {!provinciaDefault && (
                    <div className='mt-[-20px]'>
                        <Ubicacion
                            disabled={!!datos.id_obrero}
                            id_provincia={datos.id_provincia}
                            handleChangeProvincia={(e) =>
                                setDatos({ ...datos, id_provincia: Number(e.target.value) })
                            }
                        />
                    </div>
                )}
            </div>
        </TableCell>
    </TableRow>
        <TableRow colSpan="4">
            <div style={{display:'flex',justifyContent:'end', paddingTop: 4, paddingBottom: 4}}>
            {!datosMinistroOk()[0] && <Alert severity={datosMinistroOk()[0]? 'info' : 'error'}>
                        {datosMinistroOk()[1]}
            </Alert>}
                    <Button style={{margin:'1rem'}} variant='contained' color='primary' onClick={iniciarGrabar}>Aceptar</Button>
                    {!!datos.id_obrero && <Button variant='text' onClick={limpiar}>Cancelar</Button>}

            </div>
        </TableRow>
       
        </TableBody>
      </Table>
    </TableContainer>
    </Card>
}

